/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './HubSpotFormsSkillsService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#createForm
 */
export const CREATE_FORM_MUTATION_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_createForm';
export const CREATE_FORM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_FORM_MUTATION_FIELD_NAME,
  args: ['userInput', 'businessUnitId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createFormRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#getStatus
 */
export const GET_STATUS_QUERY_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_getStatus';
export const GET_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STATUS_QUERY_FIELD_NAME,
  args: ['executionId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#migrateLegacyForm
 */
export const MIGRATE_LEGACY_FORM_MUTATION_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_migrateLegacyForm';
export const MIGRATE_LEGACY_FORM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MIGRATE_LEGACY_FORM_MUTATION_FIELD_NAME,
  args: ['legacyFormId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.migrateLegacyFormRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#getMigrationStatus
 */
export const GET_MIGRATION_STATUS_QUERY_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_getMigrationStatus';
export const GET_MIGRATION_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MIGRATION_STATUS_QUERY_FIELD_NAME,
  args: ['executionId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getMigrationStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#updateFormStyle
 */
export const UPDATE_FORM_STYLE_MUTATION_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_updateFormStyle';
export const UPDATE_FORM_STYLE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_FORM_STYLE_MUTATION_FIELD_NAME,
  args: ['formId', 'userInput'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.updateFormStyleRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#getFormStylingStatus
 */
export const GET_FORM_STYLING_STATUS_QUERY_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_getFormStylingStatus';
export const GET_FORM_STYLING_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FORM_STYLING_STATUS_QUERY_FIELD_NAME,
  args: ['executionId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getFormStylingStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#createStagedForm
 */
export const CREATE_STAGED_FORM_MUTATION_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_createStagedForm';
export const CREATE_STAGED_FORM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_STAGED_FORM_MUTATION_FIELD_NAME,
  args: ['userInput', 'businessUnitId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.createStagedFormRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#getStagedFormStatus
 */
export const GET_STAGED_FORM_STATUS_QUERY_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_getStagedFormStatus';
export const GET_STAGED_FORM_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STAGED_FORM_STATUS_QUERY_FIELD_NAME,
  args: ['executionId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getStagedFormStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService#getGenerativeAiEnabled
 */
export const GET_GENERATIVE_AI_ENABLED_QUERY_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsSkillsService_getGenerativeAiEnabled';
export const GET_GENERATIVE_AI_ENABLED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_GENERATIVE_AI_ENABLED_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getGenerativeAiEnabledRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});